import styled from 'styled-components';
import EditSvg from '../../assets/settings/edit.svg';

const EditIcon = styled(EditSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '1.8rem'};
height: ${props => props.height || '1.7rem'};
margin: ${props => props.margin};
fill: ${props => props.fill};
cursor: pointer;
`;

export default EditIcon;
